<template>
    <div class="codeInput">
        <el-input placeholder="请输入验证码" v-model.trim="formSave.code" class="code_input" clearable maxlength="6"
            @change="codeInputChange()">
        </el-input>
        <button type="button" :class="checkCodeBtn.disabled
            ? 'verifyCode-btn verifyCode-btn-active'
            : 'verifyCode-btn'
            " v-preventReClick @click="onShowSlide(2)">
            <!-- @click="getCheckCode(2)" -->
            <span>{{ checkCodeBtn.text }}</span>
        </button>
    </div>
    <Verify mode="pop" :captchaType="captchaType" :imgSize="{ width: '400px', height: '200px' }" ref="verify"
        @successData="handleSuccess"></Verify>
</template>
<script lang="ts">
import { reactive, toRefs, defineComponent, ref, onMounted } from 'vue';
import { useUserStore } from '@/store/User';
import { useRouter } from 'vue-router';
import loginApi from '@/api/PcModule/login';
import Verify from '@/components/ProShop/verifition/Verify.vue';
import {
    isPhone,
} from "@/utils/validate";
import { isMobileDevice } from '@/utils/common';
export default defineComponent({
    name: 'codeInput',
    components: {
        Verify,
    },
    props: {
        phone: {
            type: String,
            default: ''
        },
        btnname: {
            type: String,
            default: ''
        }
    },
    setup(props, content) {
        const store = useUserStore();
        const data = reactive({});
        const refData = toRefs(data);
        let checkCodeBtn = reactive<any>({
            text: props.btnname || '获取验证码',
            loading: false,
            disabled: false,
            duration: 60,
            timer: null,
        });
        let formSave = reactive({
            telephone: '',
            code: '',
        });
        const captchaType = ref('');
        const verify = ref(null);
        onMounted(() => {
            clearInterval(checkCodeBtn.timer);
            checkCodeBtn.duration = 60;
            localStorage.removeItem(`startTime1${checkCodeBtn.duration}`);
        });
        const handleSuccess = async (res) => {
            if (res.result) {
                checkCodeBtn.duration = 60;
                sendSms();
                formSave.captcha_type = res.captchaType;
                formSave.point_json = res.pointJson;
                formSave.result = res.result;
                formSave.token = res.token;
                getCheckCode();
            }
        };

        const sendSms = async () => {
            let { data } = await loginApi.RegisterCodePhone({
                phone: props.phone,
            });
        };

        const onShowSlide = (once) => {
            if (once === 2 && checkCodeBtn.disabled === false) {
                if (isPhone(props.phone) === false) {
                    return false;
                }
            }
            if (checkCodeBtn.disabled === false) {
                captchaType.value = isMobileDevice() ? 'clickWord' : 'blockPuzzle';
                setTimeout(() => {
                    verify.value.show();
                }, 350);
            }
        };

        // 根据用户名获取验证码
        const getCheckCode = () => {
            // 倒计时期间按钮不能单击
            if (checkCodeBtn.duration !== 60) {
                checkCodeBtn.disabled = true;
            }
            let startTime = localStorage.getItem(
                `startTime1${checkCodeBtn.duration}`,
            );
            let nowTime = new Date().getTime();
            if (startTime) {
                let surplus = 60 - parseInt((nowTime - startTime) / 1000, 10);
                checkCodeBtn.duration = surplus <= 0 ? 0 : surplus;
                checkCodeBtn.disabled = true;
                checkCodeBtn.text = `剩余${checkCodeBtn.duration}秒`;
            } else {
                if (!checkCodeBtn.disabled) {
                    checkCodeBtn.duration = 60;
                    localStorage.setItem(
                        `startTime1${checkCodeBtn.duration}`,
                        nowTime,
                    );
                }
            }

            // 清除掉定时器
            checkCodeBtn.timer && clearInterval(checkCodeBtn.timer);
            // 开启定时器
            checkCodeBtn.timer = setInterval(() => {
                const tmp = checkCodeBtn.duration--;
                checkCodeBtn.text = `剩余${tmp}秒`;
                if (tmp <= 0) {
                    // 清除掉定时器
                    clearInterval(checkCodeBtn.timer);
                    checkCodeBtn.duration = 60;
                    checkCodeBtn.text = '重新获取';
                    // 设置按钮可以单击
                    checkCodeBtn.disabled = false;
                    localStorage.removeItem(
                        `startTime1${checkCodeBtn.duration}`,
                    );
                } else {
                    checkCodeBtn.disabled = true;
                }
            }, 1000);
        };

        const codeInputChange = () => {
            content.emit('codeInputChange', formSave.code)
        }

        return {
            ...refData,
            captchaType,
            verify,
            checkCodeBtn,
            handleSuccess,
            sendSms,
            onShowSlide,
            formSave,
            codeInputChange,
            getCheckCode
        };
    },
});
</script>
<style lang="scss">
.codeInput {
    .code_input {
        width: 250px !important;
    }

    .verifyCode-btn {
        width: 140px;
        height: 40px;
        border-radius: 8px;
        background-color: #0071DC;
        color: #fff;
        font-size: 14px;
        border: none;
        margin-left: 15px;
    }

    .verifyCode-btn-active {
        background-color: #BEBEBE;
    }
}
</style>
